<template>
  <div id="myDesk">
    <header-top></header-top>
    <div class="main">
      <div class="desk-left">
        <div class="new-report">
          <div class="report-num">
            <div class="report-tit">报备新增数</div>
            <div class="report-info">
              <img src="@/assets/image/developments.png" alt="" />
              <div class="report-val">{{ todayReservationCount }}</div>
            </div>
          </div>
          <div class="month-on-day">
            <div class="month-on-day-tit">日环比</div>
            <div class="month-on-day-info">
              <img
                src="@/assets/image/group-decline.png"
                class="group"
                v-if="reservationRate < 0"
                alt=""
              />
              <img
                src="@/assets/image/group-rise.png"
                class="group"
                v-else
                alt=""
              />
              <div class="month-on-day-val">{{ reservationRate }}%</div>
            </div>
          </div>
        </div>
        <div class="new-report">
          <div class="report-num">
            <!-- 案场  -->
            <div class="report-tit">带看新增数</div>
            <div class="report-info">
              <img src="@/assets/image/home-icon.png" alt="" />
              <div class="report-val">{{ todayVisitCount }}</div>
            </div>
          </div>
          <div class="month-on-day">
            <div class="month-on-day-tit">日环比</div>
            <div class="month-on-day-info">
              <img
                src="@/assets/image/group-decline.png"
                class="group"
                v-if="visitRate < 0"
                alt=""
              />
              <img
                src="@/assets/image/group-rise.png"
                class="group"
                v-else
                alt=""
              />
              <div class="month-on-day-val">{{ visitRate }}%</div>
            </div>
          </div>
        </div>
        <div class="transaction-report" v-loading="isStoreLoading">
          <div class="flex-between m-b-27">
            <div class="main-title m-b-0">部门销售排行榜</div>
            <el-dropdown @command="handleStoreCommand">
              <span class="el-dropdown-link">
                {{ storeDate }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="1">本日</el-dropdown-item>
                <el-dropdown-item :command="7">近七天</el-dropdown-item>
                <el-dropdown-item :command="30">近一月</el-dropdown-item>
                <el-dropdown-item :command="90">近三月</el-dropdown-item>
                <el-dropdown-item :command="365">近一年</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="ranking-list" v-if="rankingList.length">
            <div
              class="ranking flex-between"
              v-for="(item, index) in rankingList"
              :key="index"
            >
              <div class="flex">
                <img src="@/assets/image/lv1.png" alt="" v-if="index == 0" />
                <img
                  src="@/assets/image/lv2.png"
                  alt=""
                  v-else-if="index == 1"
                />
                <img
                  src="@/assets/image/lv3.png"
                  alt=""
                  v-else-if="index == 2"
                />
                <div v-if="index >= 3" class="index">{{ index + 1 }}</div>
                <div class="ranking-name">
                  {{ item.organizationUnit || "--" }}
                </div>
              </div>
              <div class="ranking-num">{{ item.count }} 单</div>
            </div>
          </div>
          <div class="ranking-none" v-else>暂无排行数据</div>
        </div>
      </div>
      <div class="desk-center">
        <div class="developments-report">
          <div class="main-title">
            客户报备统计
            <div class="btn-box">
              <el-dropdown @command="handleCommand">
                <el-button type="primary" round
                  >{{ btnText }}<i class="el-icon-arrow-down el-icon--right"></i
                ></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="1">本日</el-dropdown-item>
                  <el-dropdown-item :command="7">近七天</el-dropdown-item>
                  <el-dropdown-item :command="30">近一月</el-dropdown-item>
                  <el-dropdown-item :command="90">近三月</el-dropdown-item>
                  <el-dropdown-item :command="365">近一年</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-button type="primary" round @click="goReport"
                >查看详情</el-button
              >
            </div>
          </div>
          <div id="marketingChart"></div>
        </div>
        <div class="project-trends" v-loading="isEstateLoading">
          <div class="flex-between m-b-27">
            <div class="main-title m-b-0">楼盘带看排行榜</div>
            <el-dropdown @command="handleEstateCommand">
              <span class="el-dropdown-link">
                {{ estateDate
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="1">本日</el-dropdown-item>
                <el-dropdown-item :command="7">近七天</el-dropdown-item>
                <el-dropdown-item :command="30">近一月</el-dropdown-item>
                <el-dropdown-item :command="90">近三月</el-dropdown-item>
                <el-dropdown-item :command="365">近一年</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="ranking-list" v-if="estateList.length">
            <div
              class="ranking flex-between"
              v-for="(item, index) in estateList"
              :key="index"
            >
              <div class="flex">
                <img src="@/assets/image/lv1.png" alt="" v-if="index == 0" />
                <img
                  src="@/assets/image/lv2.png"
                  alt=""
                  v-else-if="index == 1"
                />
                <img
                  src="@/assets/image/lv3.png"
                  alt=""
                  v-else-if="index == 2"
                />
                <div v-if="index >= 3" class="index">{{ index + 1 }}</div>
                <div class="ranking-name">{{ item.estateName }}</div>
              </div>
              <div class="ranking-num">{{ item.totalCount }} 人</div>
            </div>
          </div>
          <div class="ranking-none" v-else>暂无排行数据</div>
        </div>
      </div>
      <div class="desk-right" v-loading="isBrokerLoading">
        <div class="flex-between m-b-27">
          <div class="main-title m-b-0">经纪人销售排行榜</div>
          <el-dropdown @command="handleBrokerCommand">
            <span class="el-dropdown-link">
              {{ brokerDate }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1">本日</el-dropdown-item>
              <el-dropdown-item :command="7">近七天</el-dropdown-item>
              <el-dropdown-item :command="30">近一月</el-dropdown-item>
              <el-dropdown-item :command="90">近三月</el-dropdown-item>
              <el-dropdown-item :command="365">近一年</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="ranking-list" v-if="brokerList.length">
          <div
            class="ranking flex-between"
            v-for="(item, index) in brokerList"
            :key="index"
          >
            <div class="flex">
              <img src="@/assets/image/lv1.png" alt="" v-if="index == 0" />
              <img src="@/assets/image/lv2.png" alt="" v-else-if="index == 1" />
              <img src="@/assets/image/lv3.png" alt="" v-else-if="index == 2" />
              <div v-if="index >= 3" class="index">{{ index + 1 }}</div>
              <div class="ranking-name">{{ item.userName }}</div>
            </div>
            <div class="ranking-num">{{ item.count }} 单</div>
          </div>
        </div>
        <div class="ranking-none" v-else>暂无排行数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import echarts from "echarts";
import {
  getDynamicList,
  getEstateStatistics,
  getStoreRankList,
  getEstateFollowRankList,
  getBrokerRankList,
  getReportReservationRatio,
} from "@/http/api/report";
import { getUsersSearch } from "@/http/api/employe";
import { dateFormat } from "@/common/filters";
export default {
  components: {
    headerTop,
  },
  data() {
    return {
      isStoreLoading: false,
      isEstateLoading: false,
      isBrokerLoading: false,
      todayReservationCount: 0,
      todayVisitCount: 0,
      reservationRate: 0,
      visitRate: 0,
      type: "",
      btnText: "近三月",
      storeDate: "近三月",
      estateDate: "近三月",
      brokerDate: "近三月",
      searchText: "楼盘数据统计",
      daterange: [],
      dynamicList: [],
      search: "",
      netSignList: [],
      rankingList: [],
      estateList: [],
      brokerList: [],
      animate: false,
      statisticsQuery: {
        startTime: dateFormat(new Date(new Date().toLocaleDateString())),
        endTime: dateFormat(new Date()),
      },
      storeQuery: {
        startTime: "",
        endTime: "",
      },
      estateQuery: {
        startTime: "",
        endTime: "",
      },
      brokerQuery: {
        startTime: "",
        endTime: "",
      },
      searchOptions: [
        {
          value: "前缀搜索",
          label: "前缀搜索",
        },
        {
          value: "楼盘名称",
          label: "楼盘名称",
        },
        {
          value: "楼盘地址",
          label: "楼盘地址",
        },
        {
          value: "项目负责人",
          label: "项目负责人",
        },
      ],
    };
  },
  mounted() {
    this.handleCommand(90);
    this.handleStoreCommand(90);
    this.handleEstateCommand(90);
    this.handleBrokerCommand(90);
    this.getDynamicList();
    this.getReportReservationRatio();
  },
  methods: {
    getReportReservationRatio() {
      getReportReservationRatio().then((res) => {
        let todayReservationCount = res.result.todayReservationCount;
        let todayVisitCount = res.result.todayVisitCount;
        let yesterdayReservationCount = res.result.yesterdayReservationCount;
        let yesterdayVisitCount = res.result.yesterdayVisitCount;
        if (yesterdayReservationCount) {
          this.reservationRate =
            ((todayReservationCount - yesterdayReservationCount) /
              yesterdayReservationCount) *
            100;
          this.reservationRate = this.roundToTwoDecimalPlaces(this.reservationRate);
        }else if (todayReservationCount) {
          this.reservationRate = 100;
        }
        if (yesterdayVisitCount) {
          this.visitRate =
            ((todayVisitCount - yesterdayVisitCount) / yesterdayVisitCount) *
            100;
          this.visitRate = this.roundToTwoDecimalPlaces(this.visitRate);
        }else if (todayVisitCount) {
          this.visitRate = 100;
        }
        this.todayReservationCount = todayReservationCount;
        this.todayVisitCount = todayVisitCount;
      });
    },
    roundToTwoDecimalPlaces(number) {
      // Number.isInteger() 来检查一个数字是否是整数
      if (Number.isInteger(number)) {
        return number.toString(); // 如果是整数，返回字符串形式，避免补0
      } else {
        return number.toFixed(2); // 如果有小数部分，保留两位小数
      }
    },
    scroll() {
      this.animate = true; // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
      setTimeout(() => {
        //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
        this.netSignList.push(this.netSignList[0]); // 将数组的第一个元素添加到数组的
        this.netSignList.shift(); //删除数组的第一个元素
        this.animate = false; // margin-top 为0 的时候取消过渡动画，实现无缝滚动
      }, 1000);
    },
    handleBrokerCommand(command) {
      this.brokerQuery.startTime = new Date(
        new Date(
          new Date().getTime() - 24 * 60 * 60 * 1000 * command
        ).toLocaleDateString()
      );
      if (command === 1) {
        this.brokerDate = "本日";
      } else if (command == 7) {
        this.brokerDate = "近七天";
      } else if (command == 30) {
        this.brokerDate = "近一月";
      } else if (command == 90) {
        this.brokerDate = "近三月";
      } else if (command == 365) {
        this.brokerDate = "近一年";
      }
      this.brokerQuery.endTime = new Date();
      this.brokerQuery.startTime = dateFormat(this.brokerQuery.startTime);
      this.brokerQuery.endTime = dateFormat(this.brokerQuery.endTime);
      this.getBrokerRankList();
    },
    handleStoreCommand(command) {
      this.storeQuery.startTime = new Date(
        new Date(
          new Date().getTime() - 24 * 60 * 60 * 1000 * command
        ).toLocaleDateString()
      );
      if (command === 1) {
        this.storeDate = "本日";
      } else if (command == 7) {
        this.storeDate = "近七天";
      } else if (command == 30) {
        this.storeDate = "近一月";
      } else if (command == 90) {
        this.storeDate = "近三月";
      } else if (command == 365) {
        this.storeDate = "近一年";
      }
      this.storeQuery.endTime = new Date();
      this.storeQuery.startTime = dateFormat(this.storeQuery.startTime);
      this.storeQuery.endTime = dateFormat(this.storeQuery.endTime);
      this.getStoreRankList();
    },
    handleEstateCommand(command) {
      this.estateQuery.startTime = new Date(
        new Date(
          new Date().getTime() - 24 * 60 * 60 * 1000 * command
        ).toLocaleDateString()
      );
      if (command === 1) {
        this.estateDate = "本日";
      } else if (command == 7) {
        this.estateDate = "近七天";
      } else if (command == 30) {
        this.estateDate = "近一月";
      } else if (command == 90) {
        this.estateDate = "近三月";
      } else if (command == 365) {
        this.estateDate = "近一年";
      }
      this.estateQuery.endTime = new Date();
      this.estateQuery.startTime = dateFormat(this.estateQuery.startTime);
      this.estateQuery.endTime = dateFormat(this.estateQuery.endTime);
      this.getEstateFollowRankList();
    },
    handleCommand(command) {
      this.statisticsQuery.startTime = new Date(
        new Date(
          new Date().getTime() - 24 * 60 * 60 * 1000 * command
        ).toLocaleDateString()
      );

      if (command === 1) {
        this.btnText = "本日";
      } else if (command == 7) {
        this.btnText = "近七天";
      } else if (command == 30) {
        this.btnText = "近一月";
      } else if (command == 90) {
        this.btnText = "近三月";
      } else if (command == 365) {
        this.btnText = "近一年";
      }
      this.statisticsQuery.endTime = new Date();
      this.statisticsQuery.startTime = dateFormat(
        this.statisticsQuery.startTime
      );
      this.statisticsQuery.endTime = dateFormat(this.statisticsQuery.endTime);
      this.getEstateStatistics();
    },
    getEstateStatistics() {
      getEstateStatistics(this.statisticsQuery).then((res) => {
        if (res.code == 10200) {
          let data = [];
          let info = res.result.items;
          let netSignCount = 0,
            reservationCount = 0,
            visitCount = 0,
            recognitionCount = 0;
          info.map((el) => {
            netSignCount = netSignCount + el.netSignCount;
            reservationCount = reservationCount + el.reservationCount;
            visitCount = visitCount + el.visitCount;
            recognitionCount = recognitionCount + el.recognitionCount;
          });
          data = [
            {
              date: "网签",
              entry: netSignCount,
            },
            {
              date: "报备",
              entry: reservationCount,
            },
            {
              date: "带看",
              entry: visitCount,
            },
            {
              date: "认购",
              entry: recognitionCount,
            },
          ];
          this.tntryTrendChart(data);
        }
      });
    },
    //部门排行榜
    getStoreRankList() {
      this.isStoreLoading = true;
      getStoreRankList(this.storeQuery)
        .then((res) => {
          let arr = res.result.items;
          this.rankingList = arr.splice(0, 5);
          this.isStoreLoading = false;
        })
        .catch(() => {
          this.isStoreLoading = false;
        });
    },
    // 楼盘排行榜
    getEstateFollowRankList() {
      this.isEstateLoading = true;
      getEstateFollowRankList(this.estateQuery)
        .then((res) => {
          let arr = res.result.items;
          this.estateList = arr.splice(0, 5);
          this.isEstateLoading = false;
        })
        .catch(() => {
          this.isEstateLoading = false;
        });
    },
    getBrokerRankList() {
      this.isBrokerLoading = true;
      getBrokerRankList(this.brokerQuery)
        .then((res) => {
          let arr = res.result.items;
          this.brokerList = arr.splice(0, 10);
          this.isBrokerLoading = false;
        })
        .catch(() => {
          this.isBrokerLoading = false;
        });
    },
    getDynamicList() {
      getDynamicList().then((res) => {
        this.dynamicList = res.result.items;
      });
    },
    goReport() {
      this.$router.push({ path: "/report/estate-report" });
    },
    tntryTrendChart(tntryTrendData) {
      var date = [],
        entry = [];
      for (let tntryTrend of tntryTrendData) {
        date.push(tntryTrend.date);
        entry.push(tntryTrend.entry);
      }

      let myChart = echarts.init(document.getElementById("marketingChart"));
      let option = {
        // title: {
        //   text: "折线图堆叠"
        // },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          x: "center", // 'center' | 'left' | {number},
          y: "bottom", // 'center' | 'bottom' | {number}
        },
        grid: {
          top: "20px",
          left: "0",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            // saveAsImage: {}
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: date,
        },
        // yAxis: {
        //   type: "value",
        // },
        yAxis: {
          ype: "value",
          minInterval: 1,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#999",
            },
          },
        },
        series: [
          {
            // name: "报备人数",
            type: "bar",
            data: entry,
            barGap: "-100%",
            barCategoryGap: "90%",
            animation: false,
            itemStyle: {
              barBorderRadius: [10, 10, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#ff792e" },
                { offset: 0.5, color: "#ffa877" },
                { offset: 1, color: "#fff4e6" },
              ]),
            },
          },
        ],
      };
      myChart.setOption(option);
      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  },
};
</script>

<style scoped lang='scss'>
@import "@/styles/mixin.scss";
@mixin title {
  margin-bottom: 27px;
  font-size: 16px;
  color: #000;
}
#myDesk {
  .main {
    @include flex(row, flex-start);
    justify-content: space-between;
    padding: 20px;
    .desk-left {
      @include flex(column, center);
      margin-right: 20px;
      .new-report,
      .new-agent,
      .new-turnover,
      .new-store {
        @include flex(row, flex-start);
        margin-bottom: 20px;
        padding: 20px 30px;
        border-radius: 20px;
        width: 330px;
        background: #fff;
        .report-num,
        .agent-num,
        .turnover-num,
        .store-num,
        .month-on-day {
          @include flex(column, flex-start);
          .report-tit,
          .agent-tit,
          .turnover-tit,
          .store-tit {
            @include title;
          }
          .month-on-day-tit {
            margin-bottom: 38px;
            font-size: 14px;
            color: #111;
          }
          .report-info,
          .agent-info,
          .turnover-info,
          .store-info,
          .month-on-day-info {
            @include flex(row, center);
            img {
              margin-right: 35px;
              width: 60px;
              height: 60px;
            }
            .group {
              margin-right: 8px;
              width: 30px;
              height: 30px;
            }
            .report-val,
            .agent-val,
            .turnover-val,
            .store-val {
              font-size: 42px;
              color: $--color-primary;
            }
          }
        }
        .month-on-day {
          margin-left: 65px;
        }
      }
      .transaction-report {
        padding: 20px 30px;
        width: 330px;
        min-height: 430px;
        border-radius: 20px;
        background: #fff;
        .main-title {
          @include title;
        }
        .report-list {
          .report {
            padding: 12px 0;
            border-bottom: 1px dashed #e0e0e0;
            .report-info {
              @include flex(row, center);
              justify-content: space-between;
              .report-tit {
                color: #222;
                font-size: 14px;
              }
              .report-time {
                color: #666;
                font-size: 12px;
              }
            }
            .report-val {
              margin-top: 12px;
              color: #333;
              font-size: 14px;
            }
          }
          .anim {
            transition: all 0.5s;
            // margin-top: -30px;
          }
        }
      }
    }
    .desk-center {
      @include flex(column, center);
      margin-right: 20px;
      .developments-report {
        margin-bottom: 20px;
        padding: 20px 30px 0;
        height: 316px;
        box-sizing: border-box;
        width: 660px;
        border-radius: 20px;
        background: #fff;
        .main-title {
          @include title;
          @include flex(row, center);
          justify-content: space-between;
          ::v-deep .btn-box {
            .el-dropdown {
              margin-right: 10px;
            }
            .is-round {
              border-radius: 20px !important;
            }
          }
        }
        #marketingChart {
          width: 100%;
          height: 220px;
        }
      }
      .project-trends {
        height: 430px;
        padding: 20px 30px;
        width: 600px;
        border-radius: 20px;
        background: #fff;
        .main-title {
          @include title;
          margin-bottom: 0;
        }
        .project-list {
          .project {
            padding: 12px 0;
            border-bottom: 1px dashed #e0e0e0;
            .project-info {
              @include flex(row, center);
              justify-content: space-between;
              .project-tit {
                color: #222;
                font-size: 14px;
              }
              .project-time {
                color: #666;
                font-size: 12px;
              }
            }
            .project-val {
              margin-top: 12px;
              color: #333;
              font-size: 14px;
            }
          }
          .none-project {
            height: 375px;
            line-height: 375px;
            text-align: center;
            font-size: 20px;
            color: #999;
          }
        }
      }
    }
    .desk-right {
      padding: 20px 30px;
      width: 600px;
      min-height: 767px;
      border-radius: 20px;
      background: #fff;
      .main-title {
        @include title;
        @include flex(row, center);
        justify-content: space-between;
        ::v-deep .btn-box {
          .is-round {
            border-radius: 20px !important;
          }
        }
      }
    }
    .ranking-list {
      .ranking {
        @include flex(row, center);
        margin-bottom: 30px;
        &:last-child {
          margin: 0;
        }
        img {
          margin-right: 10px;
          width: 27px;
          height: auto;
        }
        .index {
          width: 27px;
          height: 32px;
          line-height: 32px;
          margin-right: 10px;
          text-align: center;
          color: #666666;
        }
        .ranking-name {
          margin-right: 10px;
          width: 200px;
          color: #062c79;
        }
        .ranking-num {
          color: #062c79;
        }
      }
    }
    .ranking-none {
      text-align: center;
      height: 200px;
      line-height: 200px;
      color: #999;
    }
  }

  .m-b-27 {
    margin-bottom: 27px;
  }

  .m-b-0 {
    margin-bottom: 0 !important;
  }

  .el-dropdown-link {
    cursor: pointer;
  }
}
</style>